/* =========================================================
   ROBOTS
========================================================= */

import React from "react";
import SectionHeader from "../components/SectionHeader";

const PlatformRobotsSection = ({ data }) => (
    <section id="robots">

        <div className="container">

            <SectionHeader
                title={data.title}
                description={data.description}
            />

            <div className="robot-grid">

                {(data.items || []).map((item, i) => (
                    <div className="robot-card" key={i}>

                        <div
                            className="robot-image"
                            style={
                                item.image
                                    ? {
                                        backgroundImage: `url(${item.image})`,
                                        backgroundSize: "contain",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat"
                                    }
                                    : {}
                            }
                        >
                            {!item.image && item.icon}
                        </div>

                        <div className="robot-content">

                            <h3>{item.title}</h3>

                            <p>{item.description}</p>
                            <a
                            href={item.url || "#"}
                            className="learn-more"
                        >
                            {item.linkText || "Explore robot →"}
                        </a>

                        </div>

                    </div>
                ))}

            </div>

        </div>

    </section>
);


export default PlatformRobotsSection;